import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';
import { environment } from '../../../../../../../environments/environment';
import { ImageUtils } from '../../../../../../common/utils/image-utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-cell-image-uploader',
  templateUrl: './image-uploader-table-cell.component.html',
  styles: ['.small-image { height: 36px;width: 36px;}'],
  standalone: false,
})
export class ImageUploaderTableCellComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: string;

  @Input() editMode: boolean;

  imageSrc: string;

  constructor(
    private environmentService: EnvironmentService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit() {
    if (this.data !== undefined) {
      if (typeof this.data === 'string' && this.data.indexOf('./assets/') >= 0) {
        this.imageSrc = ImageUtils.relocateImage(this.data);
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  ngOnDestroy() {}
}
